
// product-banner-slider 
if ($('.js-slide-for__img').length > 0) {
    $('.js-slide-for__img').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: '<button type="button" class="prev-arrow"style="aria-disabled=true"><svg width="11" height="19" viewBox="0 0 11 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.55078 1.34717L1.38752 9.51043L9.55078 17.6737" stroke="#3F2B18" stroke-width="1.5"/></svg></button>',
        nextArrow: '<button type="button" class="next-arrow"><?xml version="1.0" ?><svg width="11" height="19" viewBox="0 0 11 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.44922 1.34717L9.61248 9.51043L1.44922 17.6737" stroke="#3F2B18" stroke-width="1.5"/></svg></button>',
        fade: false,
        speed: 900,
        infinite: false,
        asNavFor: '.js-slide-now__img',
        lazyLoad: 'ondemand',
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    arrows: true,
                }
            },
            {
                breakpoint: 576,
                settings: {
                    centerMode: false,
                    arrows: true,
                    slidesToShow: 1
                }
            }
        ]
    });
    $('.js-slide-now__img').slick({
        slidesToShow: 6,
        slidesToScroll: 1,
        asNavFor: '.js-slide-for__img',
        dots: false,
        arrows: false,
        speed: 900,
        infinite: false,
        lazyLoad: 'ondemand',
        focusOnSelect: true,
    });
}


// product-banner count 
function increaseCount(a, b) {
    var input = b.previousElementSibling;
    var value = parseInt(input.value, 10);
    value = isNaN(value) ? 0 : value;
    value++;
    input.value = value;
    $("#cart_form").eq(0).submit();
}

function decreaseCount(a, b) {
    var input = b.nextElementSibling;
    var value = parseInt(input.value, 10);
    if (value > 0) {
        value = isNaN(value) ? 0 : value;
        value--;
        input.value = value;
    }
    $("#cart_form").eq(0).submit();
}

// product-banner-accordion
$(".accordion-text__header").on("click", function () {
    if ($(this).parent().hasClass("active")) {
        $(this).parent().removeClass("active");
        $(this).parent().find('.accordion-text__body').slideUp();
    } else {
        $(".accordion-text").removeClass("active");
        $(this).parent().addClass("active");
        $(".accordion-text__body").slideUp(500);
        $(this).parent().find('.accordion-text__body')
            .slideDown(500);
    }
});

// faq-tab 
$('.tab-link').click(function () {
    var tabID = $(this).attr('data-tab');
    $(this).addClass('tab-active').siblings().removeClass('tab-active');
    $('#tab-' + tabID).addClass('tab-active').siblings().removeClass('tab-active');
});

// related-blogs__content slider
if ($('.js-related-blogs__content').length > 0) {
    $('.js-related-blogs__content').slick({
        pauseOnHover: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: false,
        arrow: false,
        infinite: true,
        arrow: false,
        prevArrow: '<button type="button" class="prev-arrow slick-arrow"><svg width="11" height="19" viewBox="0 0 11 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.55102 1.34692L1.38775 9.51019L9.55102 17.6735" stroke="#3F2B18" stroke-width="1.5"/></svg></button>',
        nextArrow: '<button type="button" class="next-arrow slick-arrow"><svg width="11" height="19" viewBox="0 0 11 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.44897 1.34692L9.61224 9.51019L1.44897 17.6735" stroke="#3F2B18" stroke-width="1.5"/></svg></button>',
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    centerMode: true,
                    slidesToShow: 1,
                    dots: true,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    centerMode: false,
                    slidesToShow: 1,
                    dots: true,
                }
            },
        ]
    });
}

// product-collection 
if($('.js-product-list-slider').length > 0){
    $('.js-product-list-slider').slick({
        pauseOnHover: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: false,
        focusOnSelect: true,
        dots: true,
        appendDots: $('.slider-dots-box'),
        dotsClass: 'slider-dots',
        arrow: true,
        centerMode: false,
        prevArrow: $('.cutsom-arrow.arrow-prev'),
        nextArrow: $('.cutsom-arrow.arrow-next'),
        responsive: [
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 1,
              }
            },
            {
              breakpoint: 391,
              settings: {
                slidesToShow: 1,
                initialSlide: 1,
              }
            }
        ]
    });
}

// clockdiv 
if($('.cart-step2').length > 0){
    function getTimeRemaining(endtime) {
        var t = Date.parse(endtime) - Date.parse(new Date());
        var seconds = Math.floor((t / 1000) % 60);
        var minutes = Math.floor((t / 1000 / 60) % 60);
        var hours = Math.floor((t / (1000 * 60 * 60)) % 6);
        return {
        'total': t,
        'hours': hours,
        'minutes': minutes,
        'seconds': seconds
        };
    }
    function initializeClock(id, endtime) {
        var clock = document.getElementById(id);
        var hoursSpan = clock.querySelector('.hours');
        var minutesSpan = clock.querySelector('.minutes');
        var secondsSpan = clock.querySelector('.seconds');
    
        function updateClock() {
        var t = getTimeRemaining(endtime);
    
        hoursSpan.innerHTML = ('0' + t.hours).slice(-2);
        minutesSpan.innerHTML = ('0' + t.minutes).slice(-2);
        secondsSpan.innerHTML = ('0' + t.seconds).slice(-2);
    
        if (t.total <= 0) {
            clearInterval(timeinterval);
        }
        }
        updateClock();
        var timeinterval = setInterval(updateClock, 1000);
    }
    var deadline = new Date(Date.parse(new Date()) +  6 * 60 * 60 * 1000);
    initializeClock('clockdiv', deadline);
}

// contact-us form

$(function() {

    function formContactUs() {
        $("#contact-us-form").validate({
            rules: {
                "contact[first_name]": "required",
                "contact[email]": { 
                    required: true,
                    email: true
                },
                "contact[phone]": { 
                    required: true,
                }
            },
            messages: {
                "contact[first_name]": "Please enter your name",
                "contact[email]": {
                    required: "Please enter your email.",
                    email: "Please Enter valid email.",
                },
                "contact[phone]": "Please enter your phone number",
            },
        });
    }

    $("#contact-us-form .btn-custom").on('click', function(e) {
        e.preventDefault();
        formContactUs();
        if($("#contact-us-form").valid() == true){
          $("#contact-us-form").submit();
        }
    });

});

    // cart cropdown 
$(function () { 
    $('.order-summary-tab').click(function () {
        $(this).next('.order-summary__content').slideToggle();
        $(this).parents('.order-summary').toggleClass("rotate");
    });
});


// pop-up slider 
// function upsellPopupSlider(){
//    if ($('.js-popular-combination-for__img').length > 0) {
//         $('.js-popular-combination-for__img').slick({
//             slidesToShow: 1,
//             slidesToScroll: 1,
//             prevArrow: '<button type="button" class="prev-arrow"style="aria-disabled=true"><svg width="11" height="19" viewBox="0 0 11 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.55078 1.34717L1.38752 9.51043L9.55078 17.6737" stroke="#3F2B18" stroke-width="1.5"/></svg></button>',
//             nextArrow: '<button type="button" class="next-arrow"><?xml version="1.0" ?><svg width="11" height="19" viewBox="0 0 11 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.44922 1.34717L9.61248 9.51043L1.44922 17.6737" stroke="#3F2B18" stroke-width="1.5"/></svg></button>',
//             fade: false,
//             speed: 900,
//             asNavFor: '.js-popular-combination-now__img',
//             responsive: [
//                 {
//                     breakpoint: 992,
//                     settings: {
//                         arrows: true,
//                     }
//                 },
//                 {
//                     breakpoint: 576,
//                     settings: {
//                         centerMode: false,
//                         arrows: true,
//                         slidesToShow: 1
//                     }
//                 }
//             ]
//         });
//         $('.js-popular-combination-now__img').slick({
//             slidesToShow: 6,
//             slidesToScroll: 1,
//             asNavFor: '.js-popular-combination-for__img',
//             dots: false,
//             arrows: false,
//             speed: 900,
//             focusOnSelect: true,
//             responsive: [
//                 {
//                     breakpoint: 992,
//                     settings: {
//                         arrows: false,
//                         slidesToShow: 4,
//                     }
//                 },
//             ]
//         });
//     }
// }
$(document).on(`click`, `.product_page_atc`, function(e) {
    if ($('.js-popular-combination-for__img').length > 0) {
        $('.js-popular-combination-for__img').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: '<button type="button" class="prev-arrow"style="aria-disabled=true"><svg width="11" height="19" viewBox="0 0 11 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.55078 1.34717L1.38752 9.51043L9.55078 17.6737" stroke="#3F2B18" stroke-width="1.5"/></svg></button>',
            nextArrow: '<button type="button" class="next-arrow"><?xml version="1.0" ?><svg width="11" height="19" viewBox="0 0 11 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.44922 1.34717L9.61248 9.51043L1.44922 17.6737" stroke="#3F2B18" stroke-width="1.5"/></svg></button>',
            fade: false,
            speed: 900,
            asNavFor: '.js-popular-combination-now__img',
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        arrows: true,
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        centerMode: false,
                        arrows: true,
                        slidesToShow: 1
                    }
                }
            ]
        });
        $('.js-popular-combination-now__img').slick({
            slidesToShow: 6,
            slidesToScroll: 1,
            asNavFor: '.js-popular-combination-for__img',
            dots: false,
            arrows: false,
            speed: 900,
            focusOnSelect: true,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        arrows: false,
                        slidesToShow: 4,
                    }
                },
            ]
        });
    }
});

if ($('.testimonial__slider-green').length > 0) {
    $('.testimonial__slider-green').slick({
        pauseOnHover: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 5000,
        focusOnSelect: true,
        dots: false,
        arrow: true,
        centerMode: true,
        prevArrow: '<button type="button" class="prev-arrow slick-arrow"><svg width="11" height="19" viewBox="0 0 11 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.55102 1.34692L1.38775 9.51019L9.55102 17.6735" stroke="#3F2B18" stroke-width="1.5"/></svg></button>',
        nextArrow: '<button type="button" class="next-arrow slick-arrow"><svg width="11" height="19" viewBox="0 0 11 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.44897 1.34692L9.61224 9.51019L1.44897 17.6735" stroke="#3F2B18" stroke-width="1.5"/></svg></button>',
        responsive: [{
            breakpoint: 768,
            settings: {
                centerMode: false,
                dots: true,
            }
        }]
    });
}
 
// select2
$(".cart-step2 .select-color #color").select2({
    allowClear: true
});




$(document).on('shopify:section:load', function(){
    if($('.js-product-list-slider').length > 0 && $('.js-product-list-slider').hasClass('slick-initialized') == false ) {
        $('.js-product-list-slider').slick({
            pauseOnHover: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            autoplay: false,
            autoplaySpeed: false,
            focusOnSelect: true,
            dots: true,
            appendDots: $('.slider-dots-box'),
            dotsClass: 'slider-dots',
            arrow: true,
            centerMode: false,
            prevArrow: $('.cutsom-arrow.arrow-prev'),
            nextArrow: $('.cutsom-arrow.arrow-next'),
            responsive: [
                {
                  breakpoint: 992,
                  settings: {
                    slidesToShow: 1,
                  }
                },
                {
                  breakpoint: 391,
                  settings: {
                    slidesToShow: 1,
                    initialSlide: 1,
                  }
                }
            ]
        });
    }
});
